export const changeRequestStatuses = {
    Unsubmitted : {id: 0, value: ""},
    Inprogress : {id: 1, value: ""},
    Approve : {id: 2, value: ""},
    Decline : {id: 3, value: ""},
}

export const checkChangeRequestDataChanged = (row) => {
    let isChanged = false;
    if(row.isShopOpen !== row.changeRequest.isShopOpen ||
        row.remarksId !== row.changeRequest.remarksId || 
        row.soldTicket !== row.changeRequest.soldTicket || 
        row.revenueAmount.tax_0 !== row.changeRequest.revenueAmount.tax_0 || 
        row.revenueAmount.tax_6 !== row.changeRequest.revenueAmount.tax_6 || 
        row.revenueAmount.tax_12 !== row.changeRequest.revenueAmount.tax_12 ||
        row.revenueAmount.tax_21 !== row.changeRequest.revenueAmount.tax_21) { 
            isChanged = true
    }
    return isChanged;
}